import React from 'react'
import { useStateValue } from '../state'

const AddPaymentButton = () => {
  const [, dispatch] = useStateValue()
  return (
    <a
      className="btn btn-myed btn-default btn-default-myed"
      onClick={() =>
        dispatch({ type: 'newPaymentModalOpen', newPaymentModalOpen: true })
      }
    >
      <div className="fal fa-plus fa-fw mr-2" /> Record New Payment
    </a>
  )
}

export default AddPaymentButton
